<template>
  <div >
    this is permission page for admin
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Permission.vue?12a5a022